import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import { PrayEngineWeb } from './PrayEngineWeb';
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <PrayEngineWeb/>
    </BrowserRouter>
  </React.StrictMode>
);

